import React, { useEffect, useState } from 'react'

import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

import "../../css/footer.css"

import logo from "../../images/logo2.png";

const Footer = (props) => {
    const [resources, setResources] = useState({});

    let navigate = useNavigate();

    const { language } = useParams();

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            break;
        case ("en" || "EN"):
            break;
        default:
            break;
    }

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    let languageNavPath = props.pagePath;

    return (
        <>
            <div className="footer">
                <div className="footer-row">
                    <div className="footer-col logo-col">
                        <a href="https://knit-fest.com/">
                            <img src={logo} alt="Knitfest Logo" className="logo" />
                        </a>
                        <div className="event-description">{resources?.FooterLogoText}</div>
                    </div>

                    <div className="footer-col browse-col">
                        <ul className="footer-list">
                            <li className="footer-title">{resources?.Footer1_Title}</li>
                            <li><a href={resources?.Footer1_1_Url}>{resources?.Footer1_1}</a></li>
                            <li><a href={resources?.Footer1_2_Url}>{resources?.Footer1_2}</a></li>
                            <li><a href={resources?.Footer1_3_Url}>{resources?.Footer1_3}</a></li>
                            <li><a href={resources?.Footer1_4_Url}>{resources?.Footer1_4}</a></li>
                            <li><a href={resources?.Footer1_5_Url}>{resources?.Footer1_5}</a></li>
                            <li><a href={resources?.Footer1_6_Url}>{resources?.Footer1_6}</a></li>
                            <li><a href={resources?.Footer1_7_Url}>{resources?.Footer1_7}</a></li>
                        </ul>
                    </div>

                    <div className="footer-col connect-col">
                        <ul className="footer-list">
                            <li className="footer-title">{resources?.Footer2_Title}</li>
                            <li><a href={resources?.Footer2_1_Url}>{resources?.Footer2_1}</a></li>
                            <li><a href={resources?.Footer2_2_Url}>{resources?.Footer2_2}</a></li>
                            <li><a href={resources?.Footer2_3_Url}>{resources?.Footer2_3}</a></li>
                            <li><a href={resources?.Footer2_4_Url}>{resources?.Footer2_4}</a></li>
                        </ul>
                    </div>

                    <div className="footer-col opening-col">
                        <ul className="footer-list">
                            <li className="footer-title">{resources?.Footer3_Title}</li>
                            <li>
                                <span>{resources?.Footer3_1}</span><br />
                                <span>{resources?.Footer3_2}</span>
                            </li>
                            <li></li>
                            <li>
                                <span>{resources?.Footer3_3}</span><br />
                                <span>{resources?.Footer3_4}</span>
                            </li>
                        </ul>
                    </div>

                    <div className="footer-col location-col">
                        <ul className="footer-list">
                            <li className="footer-title">{resources?.Footer4_Title}</li>
                            <li>
                                <span>{resources?.Footer4_1}</span><br />
                                <span>{resources?.Footer4_2}</span><br />
                                <span>{resources?.Footer4_3}</span>
                            </li>
                            <li></li>
                            <li>
                                <span dangerouslySetInnerHTML={{ __html: resources?.Footer4_4 }}></span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer